<template>
  <div class="wrapper-x-40">
    <AdminStickyHeader>
      <template #title>
        {{ face ? $t('main.title_edit_element')+":" : $t('main.title_add_element')+":" }}
        {{ $t('admin.views.faces.title') }}
      </template>
      <template #actions>
        <Loading
          v-if="loadingSaveData"
          class="mb-2"
        />
        <div class="form-group flex flex-wrap items-center gap-3">
          <button
            @click="saveData"
            type="button"
            class="btn btn-small btn-green"
          >
            {{ $t('main.button_save') }}
          </button>
          <router-link
            class="btn btn-small btn-default"
            :to="{
              name: 'faces',
              query: $route.query
            }"
          >{{ $t('main.button_cancel') }}</router-link>
        </div>
      </template>
    </AdminStickyHeader>
    <div class="form">
      <div class="flex gap-8">
        <div class="w-1/3">
          <div class="form-group">
            <label
              for="name"
              class="font-bold"
            >{{ $t('main.label_name') }}</label>
            <div class="flex items-center">
              <input
                id="name"
                type="text"
                v-model="form.name"
              />
            </div>
            <ValidationErrors :errors="errorsFor('name')" />
          </div>

          <div class="form-group">
            <label
              for="rotate_x"
              class="font-bold"
              v-html="$t('main.rotate_x')"
            ></label>
            <div class="flex items-center">
              <input
                id="rotate_x"
                type="number"
                step="5"
                v-model="form.rotate_x"
              />
            </div>
            <ValidationErrors :errors="errorsFor('rotate_x')" />
          </div>
          <div class="form-group">
            <label
              for="rotate_y"
              class="font-bold"
              v-html="$t('main.rotate_y')"
            ></label>
            <div class="flex items-center">
              <input
                id="rotate_y"
                type="number"
                step="5"
                v-model="form.rotate_y"
              />
            </div>
            <ValidationErrors :errors="errorsFor('rotate_y')" />
          </div>
          <div class="form-group">
            <label
              for="rotate_z"
              class="font-bold"
              v-html="$t('main.rotate_z')"
            ></label>
            <div class="flex items-center">
              <input
                id="rotate_z"
                type="number"
                step="5"
                v-model="form.rotate_z"
              />
            </div>
            <ValidationErrors :errors="errorsFor('rotate_z')" />
          </div>

          <div class="form-group">
            <label class="font-bold">{{ $t('main.label_status') }}: </label>
            <div>
              <button
                class="rounded flex items-center focus:outline-none gap-2"
                type="button"
                @click="form.status = form.status == 1 ? 0 : 1"
              >
                <span class="check"><i
                    v-if="form.status == 1"
                    class="fas fa-check text-red-500"
                  ></i></span>
                <span class="text-sm">{{$t('main.published')}}</span>
              </button>
            </div>
          </div>
        </div>
        <div class="w-1/3">
          <div class="form-group">
            <label class="font-bold">{{ $t('main.label_element_groups') }}: </label>
            <div
              v-if="groups&&groups.length"
              class="flex flex-col gap-2"
            >
              <button
                v-for="group in groups"
                :key="`group-${group.id}`"
                class="rounded flex items-center focus:outline-none gap-2"
                type="button"
                @click="toggleGroup(group)"
              >
                <span class="check"><i
                    v-if="form.element_groups.includes(group.id)"
                    class="fas fa-check text-red-500"
                  ></i></span>
                <span class="text-sm">{{group.name}}</span>
              </button>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import AdminStickyHeader from "../../../components/Admin/StickyHeader.vue";
import validationErrors from "../../../mixins/validationErrors";
export default {
  name: "Form",
  components: { AdminStickyHeader },
  mixins: [validationErrors],
  props: {
    face: {
      type: Object,
    },
    groups: {
      type: Array,
    },
  },
  data() {
    return {
      loadingSaveData: false,
      axes: ["x", "y", "z"],
      form: {
        name: this.face ? this.face.name : "",
        rotate_x: this.face ? this.face.rotate_x : 0,
        rotate_y: this.face ? this.face.rotate_y : 0,
        rotate_z: this.face ? this.face.rotate_z : 0,
        status: this.face ? parseInt(this.face.status) : 1,
        element_groups:
          this.face && this.face.element_groups.length
            ? this.face.element_groups.map((g) => g.id)
            : [],
      },
    };
  },
  computed: {
    licensed() {
      return this.$store.getters["licensed"];
    },
  },
  methods: {
    toggleGroup(group) {
      if (this.form.element_groups.includes(group.id)) {
        this.form.element_groups = this.form.element_groups.filter(
          (g) => g != group.id
        );
      } else {
        this.form.element_groups.push(group.id);
      }
    },
    async saveData() {
      this.errors = null;
      this.loadingSaveData = true;
      try {
        let formDataPost = new FormData();

        if (this.face) formDataPost.append("_method", "PATCH");

        formDataPost.append("name", this.form.name);

        formDataPost.append("rotate_x", this.form.rotate_x);
        formDataPost.append("rotate_y", this.form.rotate_y);
        formDataPost.append("rotate_z", this.form.rotate_z);
        formDataPost.append("status", parseInt(this.form.status));

        if (this.form.element_groups && this.form.element_groups.length) {
          for (const group_id of this.form.element_groups) {
            formDataPost.append("element_groups[]", group_id);
          }
        }

        let url = `/api/admin/faces`;
        if (this.face) url = `/api/admin/faces/${this.face.id}`;

        const res = (
          await axios.post(url, formDataPost, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
        ).data;
        const faceId = res?.data?.id;
        if (!faceId) {
          throw new Error("Некорректный ответ сервера");
        }

        if (!this.face) {
          await this.$router
            .replace({
              name: "edit_face",
              params: { id: faceId },
              query: this.$route.query,
            })
            .catch((e) => {});
        }
      } catch (error) {
        this.errors = error?.response?.data?.errors || null;
        this.status = error?.response?.status || null;
        const notification = {
          type: "error",
          message:
            error?.response?.data?.message ||
            error?.message ||
            "Ошибка при сохранении",
        };
        this.$store.dispatch("notification/add", notification, {
          root: true,
        });
      }
      this.loadingSaveData = false;
    },
  },
};
</script>
